//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { logToSentry } from "utils/networkErrorUtils";
import * as Actions from './actions';
import { handleListUserClasses } from 'store/userClasses/thunks';
export const getUserByCleverId = async (id) => {
  try {
    return apis.get("clever", `/getUserByCleverId/${id}`);
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'getting user by clever id',
                error,
                module: 'CLEVER',
                operation: 'GET_USER_BOOK_CLASS_INSTRUCTION'
            });
    }
  }
};
export const handleUserByCleverName = async (name) => {
  if(typeof name!="string") return [];
  try {
      const user = await apis.post("clever", `/get_user_by_name`,{
        body:{
          title: name
        }
      })
      return user;

  } catch (error) {
      if (error && error.message != "Network Error") {
          logToSentry({
                message: 'getting user by clever name',
                error,
                module: 'CLEVER',
                operation: 'GET_USER_BOOK_CLASS_NOTE'
            });
      }
      return ({ error: true });
  }
}


export const handleCleverUserRegistration = async (id, token) => {
  return apis.post("clever", `/registerUser`, {
    body: {
      id: id,
      token: token
    }
  });
}

export const handleCleverUserClasses = async (id, token) => {
  return apis.post("clever", `/classesAndBook`, {
    body: {
      id: id,
      token: token
    }
  });
}
export const handleCleverClassesUserSync = async (id, classId) => {
  return apis.post("clever", `/syncClassStudent`, {
    body: {
      id: id,
      classId: classId
    }
  });
}

export const handleListCleverClasses = async (id) => {
   try {
    return await apis.post("clever", `/clever/sections/list`,{
      body: {
        id: id
      }
    });
   } catch (error) {
    logToSentry({
                message: 'listing clever classes',
                error,
                module: 'CLEVER',
                operation: 'LIST_CLASS_CLASS'
            });
    return ({ error: true });
   }
}
export const handleSyncCleverClass =  (id, section,currentUser) => async dispatch => {
  try {
    const data = await apis.post('clever', `/clever/sections/create`, {
      body: {
        id,
        section
      }
    });
    if(data && data.success){
     await dispatch(handleListUserClasses(currentUser.id));
    }
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'syncing clever class',
                error,
                module: 'CLEVER',
                operation: 'SET_CLASS_CLASS'
            });
    }
    return { error: true , message: error.message }
  }
}

export const handleCleverUserLogin = async (code) => {
  try {
    return await apis.get("clever", `/usercode/${code}`)
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'handling clever user login',
                error,
                module: 'CLEVER',
                operation: 'HANDLE_CLASS_USER_LESSON'
            });
    }
    return { error: true, message: error.message }
  }

}

export const handleSyncCoteacher = (cleverUserId, sectionId, classId, currentUserId) => async dispatch => {
  try {
    const data = await apis.post('clever', `/clever/coteacher/sync`, {
      body: {
        userId: cleverUserId,
        sectionId,
        classId
      }
    });
    
    // If teachers were deleted, refresh the user classes to update the UI
    if (data && data.success && data.data && data.data.deletedCount > 0) {
      await dispatch(handleListUserClasses(currentUserId));
    }
    
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'syncing clever co-teacher',
        error,
        module: 'CLEVER',
        operation: 'SYNC_COTEACHER'
      });
    }
    return { error: true, message: error.message }
  }
}